import React, { useState } from 'react';

import * as ST from './styled';

interface IProps {
    activeComponent: React.ReactNode,
    isMobileView?: boolean,
    children?: React.ReactNode,
    blindMenuRef?: React.RefObject<HTMLDivElement>,

    // Можно управлять состоянием снаружи
    displayDropDown?: boolean,
    onMouseEnter?: () => void,
    onMouseLeave?: () => void,

    [key: string]: unknown,
}

export const BlindMenu = ({
    activeComponent,
    displayDropDown,
    isMobileView,
    children,
    blindMenuRef,
    onMouseEnter,
    onMouseLeave,
    ...rest
}: IProps): JSX.Element => {
    const [displayDropDownState, setDisplayDropDownState] = useState(false);

    const isStateless = (typeof onMouseEnter === 'function' && typeof onMouseLeave === 'function') || isMobileView;

    return (
        <ST.BlindMenu
            ref={blindMenuRef}
            data-test='blind-menu'
            onMouseEnter={isStateless ? onMouseEnter : () => setDisplayDropDownState(true)}
            onMouseLeave={isStateless ? onMouseLeave : () => setDisplayDropDownState(false)}
            {...rest}
        >
            {activeComponent}
            {(isStateless ? displayDropDown : displayDropDownState) &&
                <ST.DropDownWrapper
                    isMobileView={isMobileView}
                    data-test='drop-down-wrapper'
                >
                    <ST.DropDownContent
                        isMobileView={isMobileView}
                    >
                        {children}
                    </ST.DropDownContent>
                </ST.DropDownWrapper>
            }
        </ST.BlindMenu>
    );
};
